module.exports = __webpack_public_path__ + "img/yun.57892d9f.png";